export default __webpack_public_path__ + "media/assets/fonts/roboto-v20-latin-700-9cc0e6124996a89894204ad52a5b394d.svg";